import { render, staticRenderFns } from "./BookingConfirmDialog.vue?vue&type=template&id=5703a7f6&"
import script from "./BookingConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./BookingConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports